import React from "react"
import trans from "trans"

import {
    modal,
    Theme,
    Icon,
    css
} from "@bdfx/mergado-ui-kit"

import {URL} from "../config/api-config";
import {isGodModeOn, setUserNewsBox} from "../helpers/api";
import { getLocale } from "app/helpers/session";
import {eshopId, projectId} from "app/helpers/api";
import Mergado from "app/helpers/mergado";

export interface Props {
    showNewsBox: number
}

class ModalNewsBox extends React.PureComponent<Props, {}> {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        const {showNewsBox} = this.props

        const locale = getLocale()
        const suffix = locale.indexOf('cs') !== -1 || locale.indexOf('cz') !== -1 || locale.indexOf('sk') !== -1 ? 'cz' : 'en'

        if(!isGodModeOn && showNewsBox) {
            modal({
                overlayClassName: 'news-box-modal',
                title: <React.Fragment><Icon type={'feedimageeditor'} size={28} /> {trans("news_box_header")}</React.Fragment>,
                message: <Content>
                    <p>{trans("news_box_body")}</p>
                    <p>
                        <span className="link" onClick={() => {
                            Mergado.openWindow(`${URL.publicPath}eshop/${eshopId}/project/${projectId}/settings/showMCPConnector`)
                            this.hideNewsBox()
                        }}>
                            {trans("news_box_body_link")}
                        </span>
                    </p>
                </Content>,
                onClose: this.hideNewsBox,
            })
        }
    }

    hideNewsBox = () : boolean => {
        return !!setUserNewsBox(0)
    }

    render() {
        return false
    }
}

const Content = css('p')({
    maxWidth: '800px',
    '& img': {
        marginLeft: '-15px',
        border: '1px solid #ddd'
    },
    '& p, & li': {
        marginBottom: '10px',
        textAlign: 'left'
    },
})

const Header = css("div")({
    textAlign: "center",
    lineHeight: "1.25em",
    textTransform: "uppercase",
    color: Theme.blue,

    " .muk-icon": {
        display: "block",
        padding: "5px",
    }
})

export default ModalNewsBox
